module.exports = __webpack_public_path__ + "static/media/lead-generation-preview.876def03.png";